import {
	BPanel,
	Button,
	Form,
	FormGroup,
	Col,
	ControlLabel,
	FormControl,
	Breadcrumb,
} from '@sketchpixy/rubix';
import { Router, Link, browserHistory, withRouter } from 'react-router';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { Reactive } from '../common/Reactive.mixin.js';

import { Meteor } from 'meteor/meteor';

import { Options } from '../../collections/flights-type/options';

@withRouter
@Reactive({
	subscriptions: ["flights-type"]
})
export default class OptionsFormPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
		if(this.props.params.id)
			this.option = Options.find({_id: this.props.params.id}).fetch()[0];
		else
			this.option = {};
	}

	handleSubmit(e) {
		e.preventDefault();

		let params = {};
		let message = null;
		let method = null;

		params.attributes = {};
		_.each(this.refs, (ref, key) => {
			params.attributes[key] = ReactDOM.findDOMNode(ref).value.trim();   
		});


		if(this.props.params.id) {
			message = "L'option a été modifiée avec succès.";
			method = "options.update";
			params._id = this.props.params.id;
		}
		else {
			message = "L'option a été ajoutée avec succès.";
			method = "options.insert";
			params.attributes["createdAt"] = new Date();
		}

		Meteor.call(method, params, (function (err, _id) {

			if (err) {
				Messenger().post({
					message: err,
					type: "error"
				});
				return; 
			}

			Messenger().post({
				message: message,
				type: "success"
			});
			this.props.router.push('/options');
		}).bind(this));
	}

	render() {
		return (
			<div>
				<Breadcrumb>
					<Breadcrumb.Item>
						<Link to="/options">Options</Link>
					</Breadcrumb.Item>
					<Breadcrumb.Item href="#" active>
						Ajouter/Modifier une option
					</Breadcrumb.Item>
				</Breadcrumb>

				<BPanel header="Ajouter/Modifier une option">
					<Form horizontal onSubmit={this.handleSubmit.bind(this)}>
						<FormGroup controlId="formHorizontalEmail">
							<Col componentClass={ControlLabel} sm={2}>
								Titre de l'option
							</Col>
							<Col sm={10}>
								<FormControl type="text" ref="title" defaultValue={this.option.title}/>
							</Col>
						</FormGroup>

						<FormGroup controlId="formHorizontalEmail">
							<Col componentClass={ControlLabel} sm={2}>
								Prix de l'option
							</Col>
							<Col sm={10}>
								<FormControl type="text" ref="price" defaultValue={this.option.price}/>
							</Col>
						</FormGroup>

						<FormGroup controlId="formHorizontalPassword">
							<Col componentClass={ControlLabel} sm={2}>
								Référence*
							</Col>
							<Col sm={2}>
								<FormControl type="text" ref="reference" defaultValue={this.option.reference}/>
							</Col>
							<Col sm={8}>
								<small>* laisser vide si cette option n'existe pas sur le site.</small>
							</Col>
						</FormGroup>

						<FormGroup>
							<Col smOffset={2} sm={10}>
								<Button type="submit">
									Enregistrer
								</Button>
							</Col>
						</FormGroup>
					</Form>
				</BPanel>
			</div>
		);
	}
}

OptionsFormPage.propTypes = {
	options: React.PropTypes.array.isRequired,
};

OptionsFormPage.contextTypes = {
	router: React.PropTypes.object.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/options/OptionsForm.page.js
 **/